export default __webpack_public_path__ + "static/icon-4-2-3c7f0f923bc721604c54f5e9baedbd8e.png";